import { useApiService } from "medere-ui-framework";

export function useMedereSiteService() {
  const { api, postMethod } = useApiService();

  function getSiteLogo() {
    return api.get("/api/public/site/getImage", { responseType: "blob" })
      .then(response => URL.createObjectURL(response.data))
      .catch(error => {
        console.error("Error fetching the logo image:", error);
        throw error;
      });
  }

  function getSiteConsent() {
    return api.get("/api/public/site/getConsent", { responseType: "text" })
      .then(response => response.data)
      .catch(error => {
        console.error("Error fetching the consent:", error);
        throw error;
      });
  }

  function acceptConsent() {
    console.log("Accepting the consent");
    return postMethod({
      basePath: "/api/secured/site",
      endpoint: "/acceptConsent",
      body: null
    }).catch(error => {
      console.error("Error accepting the consent:", error);
      throw error;
    });
  }

  return {
    getSiteLogo,
    getSiteConsent,
    acceptConsent
  };
}
